import React from 'react';
import { View, StyleSheet } from 'react-native';
import { useTheme } from 'react-native-paper';
import QText from './QText';

const DrawerSection = ({ title, children, isLast = false }) => {
  const theme = useTheme();
  const styles = createStyles(theme, isLast);

  return (
    <View style={styles.sectionContainer}>
      {title && <QText style={styles.sectionTitle}>{title}</QText>}
      <View style={styles.sectionContent}>{children}</View>
    </View>
  );
};

const createStyles = (theme, isLast) =>
  StyleSheet.create({
    sectionContainer: {
      paddingVertical: 12,
      borderBottomWidth: isLast ? 0 : 1,
      borderBottomColor: theme.colors.outline,
    },
    sectionTitle: {
      fontSize: 12,
      fontWeight: '600',
      color: theme.colors.placeHolderText,
      textTransform: 'uppercase',
      letterSpacing: 0.5,
      paddingHorizontal: 16,
      paddingBottom: 8,
    },
    sectionContent: {
      // Content wrapper for menu items
    },
  });

export default DrawerSection;
